import axios from 'axios';
export const SETTING_REQUEST = 'SETTING_REQUEST'
export const SETTING_INIT = 'SETTING_INIT'
export const SETTING_SUCCESS = 'SETTING_SUCCESS'
export const SETTING_FAIL = 'SETTING_FAIL'

export const settingRequest = () => {
  return {
    type: SETTING_REQUEST
  }
}

export const settingInit = () => {
  return {
    type: SETTING_INIT
  }
}

export const settingSuccess = (data) => {
  return {
    type: SETTING_SUCCESS,
    setting: data
  }
}

export const settingFail = () => {
  return {
    type: SETTING_FAIL
  }
}

export const settingManager = () => {
  return (dispatch) => {
    dispatch(settingRequest());
    return axios.get('/api/setting/getData')
      .then(response => {
        dispatch(settingSuccess(response.data));
      })
      .catch(function (error) {
        dispatch(settingFail());
        console.log(error);
      });
  }
}

export const settings = (state = { status: 'WAITING' }, action) => {
  switch (action.type) {
    case 'SETTING_REQUEST':
      return {
        ...state,
        status: 'WAITING'
      }
    case 'SETTING_INIT':
      return {
        status: 'WAITING'
      }
    case 'SETTING_SUCCESS':
      return {
        setting: { ...action.setting },
        status: 'SUCCESS'
      }
    case 'SETTING_FAIL':
      return {
        status: 'FAIL'
      }
    default:
      return state
  }
}